// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const EllipsesIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ellipses",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.8 13.2C3.25 13.2 2 14.45 2 16s1.25 2.8 2.8 2.8zm0 5.6c1.55 0 2.8-1.25 2.8-2.8s-1.25-2.8-2.8-2.8zM16 13.2c-1.55 0-2.8 1.25-2.8 2.8s1.25 2.8 2.8 2.8zm0 5.6c1.55 0 2.8-1.25 2.8-2.8s-1.25-2.8-2.8-2.8zm11.2-5.6c-1.55 0-2.8 1.25-2.8 2.8s1.25 2.8 2.8 2.8zm0 5.6c1.55 0 2.8-1.25 2.8-2.8s-1.25-2.8-2.8-2.8z"
    })
  });
};